<template>
  <section class="hero is-primary">
    <div class="hero-body">
      <div class="container">
        <!--        <h1 class="title">-->
        <!--          Citymesh Flex Label Corner-->
        <!--        </h1>-->
        <!--        <h2 class="subtitle">-->
        <!--          Laten we samen labels maken.-->
        <!--        </h2>-->

        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <img style="height: 70px;" class="level-item" src="../../public/printhoek.png">
          </div>

          <!-- Right side -->
          <div class="level-right card px-4 py-4">
            <p class="level-item">Warehouse: </p>
            <b-select size="is-small" class="level-item" :loading="connecting" expanded v-model="selectedWarehouse" @input="warehouseSelected"
                      placeholder="Select location..">
              <option :value=null :key="0"> Select one...</option>
              <option
                  v-for="option in warehouses"
                  :value="option"
                  :key="option.name">
                {{ option.name }}
              </option>
            </b-select>

            <div class="level-item" v-if="connected">
              <b-tag type="is-success" icon="check">connected</b-tag>
            </div>
            <div class="level-item" v-else>
              <b-tag type="is-danger">disconnected</b-tag>
            </div>

              <p class="level-item">Printer: </p>
              <b-select expanded size="is-small" class="level-item" v-model="selectedPrinter"
                        :placeholder="connected ? 'Select Printer...' : 'Connect to warehouse first'">
                <option
                    v-for="option in printers"
                    :value="option"
                    :key="option">
                  {{ option }}
                </option>
              </b-select>

          </div>

        </nav>


      </div>

    </div>
    <div class="tabs is-boxed is-centered main-menu" id="nav">
      <ul>
        <li data-target="pane-1" v-on:click="currentPane = 1" id="1" v-bind:class="{ 'is-active': currentPane === 1 }">
          <a>
            <span class="icon is-small"><i class="fa fa-barcode"></i></span>
            <span>Asset Tags</span>
          </a>
        </li>
        <li data-target="pane-2" v-on:click="currentPane = 2" id="2" v-bind:class="{ 'is-active': currentPane === 2 }">
          <a>
            <span class="icon is-small"><i class="fa fa-print"></i></span>
            <span>Other Prints</span>
          </a>
        </li>
        <li data-target="pane-3" v-on:click="currentPane = 3" id="3" v-bind:class="{ 'is-active': currentPane === 3 }">
          <a>
            <span class="icon is-small"><i class="fa fa-wrench"></i></span>
            <span>RMA Labels</span>
          </a>
        </li>

      </ul>
    </div>
    <b-modal v-model="isPreviewModalActive">
      <p class="image">
        <img :src="imagePreview">
      </p>
    </b-modal>

    <div class="tab-content">
      <div class="tab-pane" v-bind:class="{ 'is-active': currentPane === 1 }" id="pane-1">
          <ErpTable @previewZPL="previewZPL" @printZPL="printZPL"/>
      </div>
      <div class="tab-pane" v-bind:class="{ 'is-active': currentPane === 2 }" id="pane-2">
        <div class="tile is-ancestor">
          <div class="tile is-parent is-6">
            <article class="tile is-child">
              <ThreeLinesLabel @previewZPL="previewZPL" @printZPL="printZPL"/>
            </article>
          </div>
          <div class="tile is-parent is-6 is-vertical">
            <article class="tile is-child">
              <TowerLabel @previewZPL="previewZPL" @printZPL="printZPL"/>
            </article>
            <article class="tile is-child">
              <NameLabel @previewZPL="previewZPL" @printZPL="printZPL"/>
            </article>
            <article class="tile is-child ">
              <CustomTextLabel @previewZPL="previewZPL" @printZPL="printZPL"/>
            </article>
            <article class="tile is-child ">
              <CustomZplLabel @previewZPL="previewZPL" @printZPL="printZPL"/>
            </article>
          </div>
        </div>

        <div class="tile is-ancestor">

          <div class="tile is-4 is-parent is-6">

          </div>

          <div class="tile is-parent is-6">
            <article class="tile is-child ">

            </article>
          </div>
        </div>

      </div>
      <div class="tab-pane" v-bind:class="{ 'is-active': currentPane === 3 }" id="pane-1">
        <RepairsTable @previewZPL="previewZPL" @printZPL="printZPL"/>
      </div>

    </div>
  </section>
</template>

<script>
import Vue from "vue"
//import {signIn} from Amplify.Auth

const qz = require("qz-tray");
import DataTable from 'vue-bulma-table'
import axios from 'axios'
import {signIn, confirmSignIn, fetchAuthSession} from 'aws-amplify/auth';
import {Amplify} from 'aws-amplify';
import moment from "moment";
import ThreeLinesLabel from "@/components/ThreeLinesLabel.vue";
import TowerLabel from "@/components/TowerLabel.vue";
import CustomTextLabel from "@/components/CustomTextLabel.vue";
import CustomZplLabel from "@/components/CustomZplLabel.vue";
import NameLabel from "@/components/NameLabel.vue";
import ErpTable from "@/components/ErpTable.vue";
import RepairsTable from "@/components/RepairsTable.vue";



export default {
  name: 'app',
  components: {
    RepairsTable,
    ErpTable,
    DataTable,
    ThreeLinesLabel,
    TowerLabel,
    CustomTextLabel,
    CustomZplLabel,
    NameLabel
  },

  data() {
    return {
      currentPane: 1,

      //Connected to QZTray instance
      connected: false,
      //// Trying to connect to QZTray instance
      connecting: false,

      // Warehouses
      warehouses: [{
        'name': "GIERLE",
        'ip': "10.182.13.2"
      }, {
        'name': "LEGEWEG",
        'ip': "10.182.10.2"
      },
        {
          'name': "LOCAL",
          'ip': "localhost"
        }],

      selectedWarehouse: null,

      // PRINTERS
      printers: [],
      selectedPrinter: null,

      // Preview
      isPreviewModalActive: false,
      imagePreview: null,

      // Labels
      amountOfLabels: 1,


    }

  },


  methods: {

    async warehouseSelected(wh) {
      this.connecting = true;
      this.connected = false;
      if (qz.websocket.isActive()) {
        await qz.websocket.disconnect();
      }

      qz.security.setCertificatePromise(function (resolve, reject) {
        resolve("-----BEGIN CERTIFICATE-----\n" +
            "MIIEKzCCAxOgAwIBAgIUS3qP2mhHr6a+07EHpvfjgZw+tv8wDQYJKoZIhvcNAQEL\n" +
            "BQAwgaMxCzAJBgNVBAYTAkJFMREwDwYDVQQIDAhGbGFuZGVyczERMA8GA1UEBwwI\n" +
            "T29zdGthbXAxGTAXBgNVBAoMEENpdHltZXNoIEZsZXggQlYxDTALBgNVBAsMBEZs\n" +
            "ZXgxFzAVBgNVBAMMDiouY2l0eW1lc2gubmV0MSswKQYJKoZIhvcNAQkBFhxsdWNr\n" +
            "YXMuZGVjbGVyY2tAY2l0eW1lc2guY29tMCAXDTI1MDEyNzA4Mzk0N1oYDzIwNTYw\n" +
            "NzIyMDgzOTQ3WjCBozELMAkGA1UEBhMCQkUxETAPBgNVBAgMCEZsYW5kZXJzMREw\n" +
            "DwYDVQQHDAhPb3N0a2FtcDEZMBcGA1UECgwQQ2l0eW1lc2ggRmxleCBCVjENMAsG\n" +
            "A1UECwwERmxleDEXMBUGA1UEAwwOKi5jaXR5bWVzaC5uZXQxKzApBgkqhkiG9w0B\n" +
            "CQEWHGx1Y2thcy5kZWNsZXJja0BjaXR5bWVzaC5jb20wggEiMA0GCSqGSIb3DQEB\n" +
            "AQUAA4IBDwAwggEKAoIBAQDUrVx9lIiCIIZlbVhsxbjPM1j4rBfZtybFO4Vl+pq/\n" +
            "I/cc/AkoQahD+U+Qdiy9FCTyf5hKuHpfo2HT5DhHsg7n4NNy8e5lyaWT2erKgdS7\n" +
            "IpOvLfVYDl9oBEK6k47BbUXfRIynxgRb0csNp6QEXEIDdSXjMLWwtpYTQb6T/tLd\n" +
            "k1+GumKLFJHwJK/SD+1zPHJqS/mJAEEEN89s6p7ulrp20jolrxDjRS8t/INZkWlk\n" +
            "Ybliji5QgZPdeQHqo+iF+4KIihQnypog3oyWtTDlXQLyhUapSIC7KZnqmVqj252A\n" +
            "03CCt3c9iAU4roteRK8wa/XXd/juuHYL+BjF8k4bDUjvAgMBAAGjUzBRMB0GA1Ud\n" +
            "DgQWBBRGKylSfQeUU/uJ2pp0LsVS1AwJ+jAfBgNVHSMEGDAWgBRGKylSfQeUU/uJ\n" +
            "2pp0LsVS1AwJ+jAPBgNVHRMBAf8EBTADAQH/MA0GCSqGSIb3DQEBCwUAA4IBAQAZ\n" +
            "/INXspXDPKh2ARQ/YS+I3CEro6600o0NPZCjGLPZ9REWtbB+JMgM2Ykx4Ozc0Wwn\n" +
            "tV/Wi0E1HxNqixbSW72QYdEUDd1ZgM58x+ywkUkzrdKDeAzEJzikSVOIGKeHr4j5\n" +
            "qZufmd9jQ9tD+/YkBSHjnnHIEd9Vo30Emt4/uYoxm6gElLWDCUoJMFTTOD5YIqKe\n" +
            "qMXF+Kdy+BuLYAsDSCDBbY0x6B7EHlwRbBmPwLnH+G9JOvK9bUhd4JY5pBw7QACY\n" +
            "WkEZzuCOiGHypZ9VRE391rzdnlbnHrgn6nOH4Dn602/+vkj+3zG4RcsDQ8wQfo89\n" +
            "jTMsA5IN/oUPXVc6pwmF\n" +
            "-----END CERTIFICATE-----\n");
      });

      var privateKey = "-----BEGIN PRIVATE KEY-----\n" +
          "MIIEuwIBADANBgkqhkiG9w0BAQEFAASCBKUwggShAgEAAoIBAQDUrVx9lIiCIIZl\n" +
          "bVhsxbjPM1j4rBfZtybFO4Vl+pq/I/cc/AkoQahD+U+Qdiy9FCTyf5hKuHpfo2HT\n" +
          "5DhHsg7n4NNy8e5lyaWT2erKgdS7IpOvLfVYDl9oBEK6k47BbUXfRIynxgRb0csN\n" +
          "p6QEXEIDdSXjMLWwtpYTQb6T/tLdk1+GumKLFJHwJK/SD+1zPHJqS/mJAEEEN89s\n" +
          "6p7ulrp20jolrxDjRS8t/INZkWlkYbliji5QgZPdeQHqo+iF+4KIihQnypog3oyW\n" +
          "tTDlXQLyhUapSIC7KZnqmVqj252A03CCt3c9iAU4roteRK8wa/XXd/juuHYL+BjF\n" +
          "8k4bDUjvAgMBAAECgf949VOlTAhXk8GpIVRciOSTWjpzNDpcZc5z+DMZzQfPrj53\n" +
          "Cnr3nZNJFbXEc9gxS0O4QaZcDCmNbpI1JGR3lZp+Rvn7/50wrX8YMaVX7hkPiQFC\n" +
          "oODpNBBCS8On83ekJOhlRpeFoRmmUnhdS8f9GUhySJTdbta0ESR9AoD7RL/cd7hw\n" +
          "Z7gUMwGfusw6iwXxZfNkv6dV3tsrCHDoDCrkGhixZzvDEJAUFNb9M18DFEZZDrnc\n" +
          "HSFSQdWXevwDs/6e9Iuo5IPcPaDGilF7UIqJB3hSptMNGz2XHfSWkVtbQ1ESbSMJ\n" +
          "48t2h4k2LUj7HFf6znJrQgtf8Dg0A4vuDIx+YkECgYEA6sMKafQAPtpuoZZa5Cjf\n" +
          "VcXxqTs2zgupMjIILgzmFthDrClJ2jd3KYB8V09/bW8s/pA5DJ0QLLvPosQS25Fq\n" +
          "XWhqYscMgYyBwDM/AZ2qKwhaKF7P57JBdEKxPp3aTEjhq0LR1E2JzAhaV4XE+Pf6\n" +
          "rlJixg20L1PLlDw3/+7dbYsCgYEA5+rZ5Av4ZPplI2fEauXBKrjs3jjSQVISHVYo\n" +
          "SfTokr/JwstX+7G0ft9dE8DWwS9Y0dL3QlevXvUm87so8l0YPKjZDku4qnwniNVW\n" +
          "fwQ7+hvjeYnjsGzZeSnMxw7C8mNMIOpmR/GIbEgK4757+e37FCJv0AIaFqV6Uf/j\n" +
          "qVmrBq0CgYAuOUkLo6eIuKmf12L+Ga4fzWHP2IDqARHHeGJz7sY/KUXp2BdaiCFG\n" +
          "Yq4Y4uZMPd+2H9+bxDEzHae8fK7Z3L/8tFp+KIMl3uyNU4nMX6bp4jMeT8zP6iFJ\n" +
          "KviLQ7l/27nTZsy56KqBKgPfx88I1ordWAtqw7f+uZkUDudX1Uh0EQKBgGJJvySO\n" +
          "CizJjhmOPclMLCyuCP05OaqjXLgALr0BRZwEGj8rLNOoAaYPhgP8I0fmiA8NCOud\n" +
          "+94Tqfl75aOp3r6+lJchclcWnS65s5nLMpwSO7rjvJKl3xkhpP7r+6T8fmQo00ZE\n" +
          "UBwMAEl7DlHjERj8a0TNzz6vzQJ5n4PDU99VAoGBAJlz32vBuwGCwppflRMZ0z0A\n" +
          "E6EdH6T6k7yrdheZitAeX3vzputEWS4F9U/VfKRlHK2WID6Em4RWsyKayzBTRQir\n" +
          "g15lJnngVGZiC/CyrYScm5c7UkXC3F9oz5jou4iw1qRc/IXWCEXX5lruJBgX5NFU\n" +
          "ybaAfSGR9/OlUtueT3j0\n" +
          "-----END PRIVATE KEY-----\n";

      qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
      qz.security.setSignaturePromise(function (toSign) {
        return function (resolve, reject) {
          try {
            var pk = KEYUTIL.getKey(privateKey);
            var sig = new KJUR.crypto.Signature({"alg": "SHA512withRSA"});  // Use "SHA1withRSA" for QZ Tray 2.0 and older
            sig.init(pk);
            sig.updateString(toSign);
            var hex = sig.sign();
            console.log("DEBUG: \n\n" + stob64(hextorstr(hex)));
            resolve(stob64(hextorstr(hex)));
          } catch (err) {
            console.error(err);
            reject(err);
          }
        };
      });

      qz.websocket.connect({host: this.selectedWarehouse.ip, usingSecure: false}).then(() => {
        return qz.printers.find();
      }).then((printers) => {
        console.log(printers);
        this.connected = true;
        this.connecting = false;
        // this.$buefy.toast.open({
        //   message: 'Printers fetched from warehouse',
        //   type: 'is-success'
        // })
        this.printers = printers

      }).then(() => {
        //return qz.websocket.disconnect();
      }).then(() => {
        // process.exit(0);
      }).catch((err) => {
        console.error(err);
        this.connected = false;
        this.connecting = false;

        // process.exit(1);
      });


    },






    // Functions for Widgets

    previewZPL(zpl, size = "2.76x1.26") {
      let thisIns = this;

      axios.get(`https://api.labelary.com/v1/printers/8dpmm/labels/${size}/0/${encodeURIComponent(zpl)}`, {
        headers: {
          'Accept': 'image/png'
        },
        responseType: 'blob'
      })
          .then(function (response) {
            thisIns.isPreviewModalActive = true
            thisIns.imagePreview = URL.createObjectURL(response.data);

          })
          .catch((error) => {
            console.log(error)
            thisIns.$buefy.notification.open({
              message: error,
              type: 'is-danger'
            })
          })
    },

    printZPL(zpl) {
      let thisIns = this;

      var config = qz.configs.create(this.selectedPrinter, {forceRaw: true});               // Exact printer name from OS

      console.log(zpl)
      qz.print(config, zpl).then(function () {
        thisIns.$buefy.toast.open({
          message: 'Labels printed successfully!',
          type: 'is-success'
        })
      });
    }


  },
}
</script>

<style>
.tabs {
  margin-bottom: -1px !important;
  position: relative;
}

.tab-content {
  padding: 60px;
  top: 197px;
  color: #000;
  background-color: #F3F6FB;
}

.tab-pane {
  display: none;
}

.tab-pane.is-active {
  display: block;
  width: 90%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.is-active {
  display: initial;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
